import * as React from 'react';
import { AXSBlock } from "@axs/axsui-axsblock";
import { AXSFlex } from "@axs/axsui-axsflex";
import { AXSFlexItem } from "@axs/axsui-axsflexitem";
import { Link } from "react-router-dom";
import styled from 'styled-components';
import VeritixLogo from '../VeritixLogo';

const PhoneNumber = styled.a`
    color: white;
    padding: 10px;
    
    &:hover {
    color: white;
    text-decoration: underline;
    }
    
    @media (max-width: 767px) {
      font-size: 12px;
    }
    
    @media (max-width: 540px) {
      font-size: 9px;
    }
`;

const HeaderNav = styled(AXSFlex)<{ displayOnMobile?: boolean }>`
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
    
    @media (max-width: 767px) {
        display: ${props =>  props.displayOnMobile ? "flex" : "none"};
    }
`;

interface HeaderProps {
    backgroundColor?: string;
    displayOnMobile?: boolean;
    useDefaultLogoLink?: boolean;
}

const Header: React.FunctionComponent<HeaderProps>  = ({backgroundColor, displayOnMobile, useDefaultLogoLink}) => (
    <AXSBlock>
        <AXSBlock backgroundColor={backgroundColor}>
            <HeaderNav alignItems="center" justifyContent="space-between" width="100%" height="50px" displayOnMobile={displayOnMobile}>
                <AXSFlexItem color="#ffffff">
                    { useDefaultLogoLink ? (
                        <Link to="/"> <VeritixLogo /> </Link>
                    ) : (
                        <VeritixLogo />
                    ) }

                </AXSFlexItem>
                <AXSFlexItem paddingRight="20px"><PhoneNumber href="tel:+18886843540">888-684-3540</PhoneNumber></AXSFlexItem>
            </HeaderNav>
        </AXSBlock>

    </AXSBlock>
);

Header.defaultProps = {
    backgroundColor: "#0054a1",
    displayOnMobile: true,
    useDefaultLogoLink: true
}

export default Header;
